// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Lek4","signatureBlock":"Footer_signatureBlock__37vTn","signature":"Footer_signature__ShVZU"};